import React, {useEffect} from "react";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {Link, useLocation, useParams} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getCurrentLoading, resetUpdateLoadingStatus, updateLoading} from "../../store/reducers/LoadingsSlice";
import {FieldArray, Form, FormikProvider, useFormik} from "formik";
import {updateCategory} from "../../store/reducers/CategoriesSlice";
import ElogSelect, {Option} from "../common/form/ElogSelect";
import {getCountries} from "../../store/reducers/CountriesSlice";
import {getServices} from "../../store/reducers/ServicesSlice";
import {getUsers} from "../../store/reducers/UsersSlice";
import ElogInput from "../common/form/ElogInput";
import {LoadingContact} from "../../models/Loading";

interface ModifyOrderScreenProps {
}

export const ModifyLoadingScreen: React.FC<ModifyOrderScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();

    const {clientId, loadingId} = useParams();

    const loadingsState = useAppSelector(state => state.loadings);
    const countriesState = useAppSelector(state => state.countries);

    const requestStatus: RequestStatus = loadingsState.updateLoadingStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Kliendid", url: "/clients"},
        {text: "Kliendi laadimised", url: `/clients/${clientId}/loadings`},
        {text: "Muuda laadimist", url: `/clients/${clientId}/loadings`},
    ];

    useEffect(() => {
        if ( loadingId ) {
            dispatch(getCurrentLoading({id:loadingId}));
            dispatch(getCountries());
        }
    }, []);

    useEffect(() => {
        dispatch(resetUpdateLoadingStatus());
    }, [location]);

    const countryOptions: Option[] = countriesState.countries.map((country) => ({
        value: country.id.toString(),
        label: country.name,
    }));

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            country: loadingsState?.currentLoading?.country_id,
            address: loadingsState?.currentLoading?.address,
            city: loadingsState?.currentLoading?.city,
            contacts: loadingsState?.currentLoading?.contacts,
        },
        onSubmit: (values: any) => {
            dispatch(updateLoading({id: loadingId, data: values}));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (<LoggedInView fullWidth={false}>
            {requestStatus === RequestStatus.Success &&
            <div className="message msg-ok">
              <div>
                <h2>Andmed muudetud</h2>
              </div>
            </div>
            }
            {requestStatus === RequestStatus.Failed && loadingsState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {loadingsState.errors.map((error, index) => (
                            <span key={index}>{error}<br/></span>
                        ))}
                    </div>
                </div>
            )}
            <Breadcrumbs links={breadcrumbLinks}/>
            <div className="form">
                <h2>
                    <span>Laadimise andmed</span>
                </h2>

                <FormikProvider value={formik}>
                    <Form onSubmit={handleSubmit}>
                            <table className="form">
                                <ElogSelect label="Riik" name="country" options={countryOptions} mandatory={true}/>
                                <ElogInput label="Linn" name="city" mandatory={true}/>
                                <ElogInput label="Aadress" name="address" mandatory={true}/>

                                <FieldArray name="contacts">
                                    {({ form, push, remove }) => (
                                        <>
                                            {form?.values?.contacts?.map((contact:LoadingContact, index:number) => (
                                                <React.Fragment key={index}>
                                                    <ElogInput label="Nimi" name={`contacts[${index}].name`} mandatory={true}/>
                                                    <ElogInput label="Email" name={`contacts[${index}].email`} mandatory={true}/>
                                                    <ElogInput label="Telefon" name={`contacts[${index}].phone`} mandatory={true} button={<button type="button" onClick={() => remove(index)}>[x]</button>}/>
                                                </React.Fragment>
                                            ))}
                                            <button type="button" onClick={() => push({ name: '', email: '', phone: '' })}>Lisa kontakt</button>
                                        </>
                                    )}
                                </FieldArray>

                            </table>

                        <div className="action clear">
                            <p>
                                <button type="submit">
                  <span>
                    <strong>Muuda</strong>
                  </span>
                                </button>
                            </p>
                        </div>
                    </Form>
                </FormikProvider>
            </div>
        </LoggedInView>
    );

}